import { enableEdmSync } from './contact_sync_types';
export class ContactSyncCustomer {
    constructor(ctx) {
        this.isSyncCustomer = false;
        this.switchCustomerEdmSync = true;
        this.ctx = ctx;
        this.contactCustomerSyncHandle = {
            eventPeriod: 'long',
            handler: ob => {
                console.log('[contact] contactSyncAllHandle', ob.seq);
                if (ob.seq > 10 && ob.seq % 20 === 0 && this.switchCustomerEdmSync) {
                    this.syncContactCustomer().catch(res => {
                        console.error('[contact] sync error:', res);
                    });
                }
            },
            id: 'contactCustomerSync',
            seq: 0,
        };
    }
    async syncCustomerListLoop(force) {
        const res = {
            orgList: [],
            managerList: [],
            contactList: [],
            orgContactList: [],
            labelList: [],
        };
        try {
            const { data, loadMore } = await this.ctx.contactServer.syncCustomerList(force);
            const arr = await Promise.all([
                this.ctx.contactEdmHelper.handleCustomerList({ data }),
                loadMore ? await this.syncCustomerListLoop() : Promise.resolve({}),
            ]);
            arr.forEach(item => {
                Object.keys(res).forEach(key => {
                    const curKey = key;
                    res[curKey] = res[curKey].concat(item[curKey] || []);
                });
            });
        }
        catch (e) {
            console.error('[contact_sync] syncCustomerList error', e);
        }
        return res;
    }
    async syncClueListLoop() {
        const res = {
            orgList: [],
            managerList: [],
            contactList: [],
            orgContactList: [],
            labelList: [],
        };
        try {
            const { data, loadMore } = await this.ctx.contactServer.syncClueList();
            const arr = await Promise.all([
                this.ctx.contactEdmHelper.handleClueList({ data }),
                loadMore ? await this.syncClueListLoop() : Promise.resolve({}),
            ]);
            arr.forEach(item => {
                Object.keys(res).forEach(key => {
                    const curKey = key;
                    res[curKey] = res[curKey].concat(item[curKey]);
                });
            });
        }
        catch (e) {
            console.error('[contact_sync] syncClueList error', e);
        }
        return res;
    }
    async syncContactCustomer(params) {
        const { isInit, force } = params || {};
        try {
            if (!this.ctx.contactUtil.getCurrentContactId()) {
                await this.ctx.accountApi.doGetMailAliasAccountListV2();
            }
            if (this.isSyncCustomer) {
                console.error('[contact_sync] syncContactCustomer error', '客户数据同步中，请稍后');
                return {
                    syncFinish: false,
                };
            }
            const start = Date.now();
            this.isSyncCustomer = true;
            if (isInit) {
                const selfRes = await this.ctx.contactServer.syncSelfCustomerList();
                await this.ctx.contactEdmHelper.handleCustomerList({ data: selfRes.data, needDeleteLastData: false });
                this.isSyncCustomer = false;
                this.ctx.contactUtil.logger('contact_edm_sync_myCustomer', this.ctx.contactUtil.useTime(start));
            }
            await this.syncCustomerListLoop(force);
            this.isSyncCustomer = false;
            this.ctx.contactEdmHelper.sendContactEdmNotify({ type: 'customer', isForce: force }, true);
            this.ctx.contactUtil.logger('contact_edm_sync_contact_customer', this.ctx.contactUtil.useTime(start));
            console.warn('[contact_edm] sync syncContactCustomer finish!');
            return {
                syncFinish: true,
            };
        }
        catch (e) {
            this.isSyncCustomer = false;
            console.error('[contact_sync] syncContactCustomer error', e);
            return {
                error: e,
                syncFinish: true,
            };
        }
    }
    setCustomerContactSync() {
        if (enableEdmSync(this.ctx)) {
            this.ctx.systemApi.intervalEvent(this.contactCustomerSyncHandle);
            if (this.ctx.contactEdmHelper.getContactEdmSyncTimes() === 0) {
                this.ctx.contactUtil.retry(this.customerContactInit.bind(this));
            }
            else {
                this.customerContactInit();
            }
            console.time('[contact_sync] app contact colleague sync first');
            this.syncContactCustomer().then(() => {
                console.timeEnd('[contact_sync] app contact colleague sync first');
            });
        }
    }
    async customerContactInit(tid) {
        const inited = await this.getTableInited({
            tableName: this.ctx.contactEdmHelper.tableNames.contact,
            dbName: this.ctx.contactEdmHelper.dbName,
        });
        if (tid) {
            clearTimeout(tid);
        }
        if (inited) {
            this.ctx.contactEdmHelper.sendContactEdmNotify();
        }
        else {
            this.syncContactCustomer({ isInit: true }).then();
        }
    }
    async getTableInited(table) {
        const count = await this.ctx.dbApi.getTableCount(table);
        return count > 0;
    }
}
